import { render, staticRenderFns } from "./scrollarea.vue?vue&type=template&id=75be98a7&scoped=true"
import script from "./scrollarea.vue?vue&type=script&lang=ts"
export * from "./scrollarea.vue?vue&type=script&lang=ts"
import style0 from "./scrollarea.vue?vue&type=style&index=0&id=75be98a7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75be98a7",
  null
  
)

export default component.exports